export default "__VITE_ASSET__BiOGdTlK__"